import { NodeReference } from '../decorators/change-tracker';
import { Kb3dModel } from '../decorators/kb3d-decorator';
import { eJoinType } from '../enums';
import { IJoinGeometryFeature } from '../kb3d-models';
import { MeshNode } from '../meshes/mesh-node';
import { Token } from '../token';
import { ALL_CHANGES, ALL_GEOMETRY, Feature } from './feature';

@Kb3dModel({
    token: Token.JoinGeometryFeature,
})
export class JoinGeometryFeature extends Feature implements IJoinGeometryFeature {
    static _affects = new Set(ALL_GEOMETRY);
    static _affectedBy = new Set(ALL_CHANGES);

    _previewVisible: boolean;
    joinType: eJoinType;
    @NodeReference(MeshNode) meshId: string;
}
